import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContainer = styled(Container)`
  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md'
    )} - 1px)) {
    width: 100%;
    margin: 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    && {
      margin-top: -180px;
    }
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 0 90px;
  }
`;

export const FeaturedImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  min-height: 345px;

  margin: 0 auto;
  max-width: 1920px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 100%;
    max-height: 640px;
  }
`;

export const Content = styled.div`
  background-color: ${themeGet('colors.secondary')};
  padding: 65px 30px 70px;

  &:hover {
    box-shadow: 10px 10px 40px 0 #c9c9c9;
  }

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md'
    )} - 1px)) {
    width: 95%;
    margin: -100px auto 0;
    border-radius: 12px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    border-radius: 12px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const ArticleTitle = styled.h2`
  color: ${themeGet('colors.text-light')};
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: auto;
  }
`;

export const Date = styled.time`
  font-family: ${themeGet('fonts.primary')};
  font-size: inherit;
  color: ${themeGet('colors.text-dark')};
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0 5px;

  &:after {
    content: '|';
    position: relative;
    right: -5px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const Author = styled.p`
  font-size: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  margin: 0 5px;
`;

export const Copy = styled.div`
  margin-bottom: 25px;

  p {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    color: ${themeGet('colors.text-light')};
  }

  &.small {
    p {
      font-size: 14px;
      letter-spacing: 0;
      line-height: 22px;
    }
  }

  &.large {
    p {
      font-size: 18px;
      font-weight: ${themeGet('font-weights.semi-bold')};
      letter-spacing: -0.41px;
      line-height: 24px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 50px;
    p {
      font-size: 18px;
      letter-spacing: -0.2px;
      line-height: 30px;
    }

    &.small {
      p {
        font-size: 15px;
        letter-spacing: -0.2px;
        line-height: 25px;
      }
    }

    &.large {
      p {
        font-size: 22px;
        letter-spacing: -0.17px;
        line-height: 32px;
      }
    }
  }
`;
